import * as Immutable from "immutable"

import { Assortment } from "./assortment"

export class ProductFamily extends Assortment {

}